import {useFlags as useLDFlags} from 'launchdarkly-react-client-sdk';

export const useFlags = () => {
  const flags = useLDFlags();

  // Rename the LaunchDarkly flag names
  return {
    allowReleaseQuota: !!flags.allowReleaseQuota,
    featuresManagerIntegration: !!flags.acornsFeaturesManagerIntegration,
    notificationsInPlatformApps: !!flags.notificationsInPlatformApps,
    showVisualAnalysis: !!flags.acornsShowVisualAnalysis,
    showCreateNewOrder: !!flags.acornsShowCreateNewOrder,
    showMapRoutes: !!flags.acornsShowMapRoutes,
    showNotificationSettingsButton: !!flags.accountEnableNotificationSettings,
    subsUiMosaics: !!flags.acornsSubsUiMosaics,
  };
};
